import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { VideoPlayer } from "../../models/video-player";

@Component({
  selector: "custom-video-player",
  templateUrl: "./custom-video-player.component.html",
  styleUrls: ["./custom-video-player.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomVideoPlayerComponent implements AfterViewInit, OnDestroy {
  @ViewChild("player", { static: false }) playerRef: ElementRef;
  @Input() src: string;

  private player: VideoPlayer;

  constructor(private translate: TranslateService) {}

  ngAfterViewInit(): void {
    const currentLang = this.translate.currentLang;
    this.player = new VideoPlayer();
    this.player.initPlayer(this.playerRef.nativeElement, currentLang, {
      sources: [
        {
          src: this.src,
          type: "application/x-mpegURL",
        },
      ],
      responsive: true,
      playbackRates: [0.5, 1, 1.5, 2],
    });
  }

  ngOnDestroy(): void {
    this.player.disposePlayer();
  }
}
